import { backendUrl } from '../constants/urls';
import clientApi from '../constants/urls';

const createBusinessType = (values) => {
	return clientApi.post(`${backendUrl}/businessType`, values);
};

const retrieveBusinessTypes = () => {
	return clientApi.get(`${backendUrl}/businessType`);
};

const updateBusinessType = (id, category) => {
	return clientApi.put(`${backendUrl}/businessType/${id}`, category);
};

const deleteBusinessType = (id: string) => {
	return clientApi.delete(`${backendUrl}/businessType/${id}`);
};

const businessTypeService = {
	createBusinessType,
	retrieveBusinessTypes,
	updateBusinessType,
	deleteBusinessType,
};

export default businessTypeService;
